export default {
  methods: {
    normalizarCadastroRapido(value) {
      return String(value || "")
        .trim()
        .toLocaleLowerCase("pt-BR");
    },
    extrairCadastroRapido(response, responseKeys = []) {
      const responseData = response?.data ?? response;

      for (const key of responseKeys) {
        if (responseData?.[key]) {
          return responseData[key];
        }
      }

      return responseData;
    },
    encontrarCadastroRapido(items, nome, idField, labelField = "nome") {
      const lista = Array.isArray(items) ? items : [];
      const nomeNormalizado = this.normalizarCadastroRapido(nome);

      return (
        lista.find(
          (item) =>
            this.normalizarCadastroRapido(item?.[labelField]) ===
            nomeNormalizado
        ) ?? (lista.length === 1 && lista[0]?.[idField] ? lista[0] : null)
      );
    },
    async resolverCadastroRapido({
      response,
      responseKeys,
      idField,
      labelField = "nome",
      nome,
      search,
    }) {
      const cadastro = this.extrairCadastroRapido(response, responseKeys);

      if (cadastro?.[idField]) {
        return cadastro;
      }

      for (let tentativa = 0; tentativa < 3; tentativa++) {
        const items = await search(nome);
        const encontrado = this.encontrarCadastroRapido(
          items,
          nome,
          idField,
          labelField
        );

        if (encontrado?.[idField]) {
          return encontrado;
        }

        await this.$nextTick();
      }

      return null;
    },
    async criarClienteCadastroRapido(nome) {
      const nomeCliente = String(nome || "").trim();
      const { data } = await this.$http.post("/pessoa/create", {
        nome: nomeCliente,
        cnpj_cpf: "",
        status: "A",
        pessoa_tipo: [
          {
            id_tipo: 1,
            descricao: "Cliente",
          },
        ],
        email: [],
        endereco: [],
        telefone: [],
        inscricoes_estaduais: [],
      });

      const cliente = await this.resolverCadastroRapido({
        response: data,
        responseKeys: ["pessoa", "cliente"],
        idField: "id_pessoa",
        nome: nomeCliente,
        search: (search) => this.getClientes(search),
      });

      if (!cliente) {
        throw new Error("Não foi possível localizar o cliente criado.");
      }

      const enderecos = Array.isArray(cliente.enderecos)
        ? cliente.enderecos
        : [];

      return {
        ...cliente,
        enderecos,
        endereco: cliente.endereco ?? enderecos[0] ?? null,
      };
    },
    async criarVendedorCadastroRapido(nome) {
      const nomeVendedor = String(nome || "").trim();
      const { data } = await this.$http.post("/vendedor/create", {
        nome: nomeVendedor,
        status: true,
        comissao_vista: 0,
        comissao_prazo: 0,
      });

      const vendedor = await this.resolverCadastroRapido({
        response: data,
        responseKeys: ["vendedor"],
        idField: "id_vendedor",
        nome: nomeVendedor,
        search: (search) => this.getVendedorByNome(search),
      });

      if (!vendedor) {
        throw new Error("Não foi possível localizar o vendedor criado.");
      }

      return vendedor;
    },
    async criarTecnicoCadastroRapido(nome) {
      const nomeTecnico = String(nome || "").trim();
      const { data } = await this.$http.post("/tecnico/create", {
        nome: nomeTecnico,
        status: true,
      });

      const tecnico = await this.resolverCadastroRapido({
        response: data,
        responseKeys: ["tecnico"],
        idField: "id_tecnico",
        nome: nomeTecnico,
        search: (search) => this.getTecnicos(search),
      });

      if (!tecnico) {
        throw new Error("Não foi possível localizar o técnico criado.");
      }

      return tecnico;
    },
    async criarObjetoCadastroRapido(descricao, idPessoa = null) {
      const descricaoObjeto = String(descricao || "").trim();
      const { data } = await this.$http.post("/objeto/create", {
        descricao: descricaoObjeto,
        status: true,
        id_pessoa: idPessoa,
        identificadores: [],
      });

      const objeto = await this.resolverCadastroRapido({
        response: data,
        responseKeys: ["objeto", "data"],
        idField: "id_objeto",
        labelField: "descricao",
        nome: descricaoObjeto,
        search: (search) => this.getObjeto(search),
      });

      if (!objeto) {
        throw new Error("Não foi possível localizar o objeto criado.");
      }

      let identificadores = objeto.identificadores;
      if (typeof identificadores === "string") {
        try {
          identificadores = JSON.parse(identificadores);
        } catch (error) {
          identificadores = [];
        }
      }

      return {
        ...objeto,
        id_pessoa: objeto.id_pessoa ?? idPessoa,
        identificadores: Array.isArray(identificadores) ? identificadores : [],
      };
    },
    mensagemErroCadastroRapido(error, fallback) {
      return (
        error?.response?.data?.msg || error?.response?.data?.message || fallback
      );
    },
  },
};
